import axios from 'axios';
import IntegrationType from '../entity/integration-type.entity';

export default class IntegrationTypeService {
  static readonly PATH_URL = '/api/v1/integration-types';

  public static getIntegrationTypes(): Promise<IntegrationType[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => IntegrationType.ofList(response.data));
  }

  public static create(integrationType: IntegrationType): Promise<IntegrationType> {
    return axios
      .post(this.PATH_URL, integrationType)
      .then((response: any) => IntegrationType.of(response.data));
  }
}
